import { useEffect, useState } from "react";
import axios from "axios";

export default function CosmeticDetailRight({ item }) {
  const rarityImages = {
    common: "unicode-common",
    rare: "unicode-rare",
    limited: "unicode-limited",
    epic: "unicode-epic",
    legendary: "unicode-legendary",
    exotic: "unicode-exotic",
    partner: "unicode-partner",
  };

  const [username] = useState(localStorage.getItem("username") || "");
  const [ownedAmount, setOwnedAmount] = useState(0);

  useEffect(() => {
    if (username) {
      axios
        .get(`https://app.zeqa.net/api/player/item/${username}`)
        .then((response) => {
          if (response.data && response.data.result.length > 0) {
            const data = response.data.result[0];
            const typeMap = {
              cape: data.ownedcape,
              artifact: data.ownedartifact,
              killphrase: data.ownedkillphrase,
              mount: data.ownedmount,
              projectile: data.ownedprojectile,
            };

            const ownedString = typeMap[item.type];
            if (ownedString) {
              const ownedArray = ownedString.split(",");
              const count = ownedArray.filter(
                (id) => id === String(item.id)
              ).length;
              setOwnedAmount(count);
            }
          }
        });
    }
  }, [username, item.id, item.type]);
  return (
    <div className="cosmetic_detail_right">
      <h1 style={{ color: "#ffc800", paddingBottom: 15, fontSize: 26 }}>
        Information
      </h1>
      <h5
        style={{
          fontFamily: "Minecraft Seven",
          fontSize: 20,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <span>Rarity : </span>
        {item.rarity === "NA" ? (
          <span style={{ marginLeft: 8 }}>No Rarity</span>
        ) : (
          <div
            className={`unicode-sprite ${rarityImages[item.rarity]}`}
            style={{ marginLeft: 8, marginTop: 4 }}
          ></div>
        )}
      </h5>
      <h5
        style={{
          fontFamily: "Minecraft Seven",
          fontSize: 20,
        }}
      >
        Tradable : {item.isTradable ? "Yes" : "No"}
      </h5>
      <h5
        style={{
          fontFamily: "Minecraft Seven",
          fontSize: 20,
        }}
      >
        Obtained via :{" "}
        {item.obtain.length ? (
          <div>
            {item.obtain.map((method, index) => (
              <div key={index}>{method}</div>
            ))}
          </div>
        ) : (
          "no data"
        )}
      </h5>
      {username && ownedAmount > 0 && (
        <h5
          style={{
            fontFamily: "Minecraft Seven",
            fontSize: 20,
          }}
        >
          You own: {ownedAmount}
        </h5>
      )}
      <br />
    </div>
  );
}
